<template>
    <presentations :presentations="presentations"/>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Presentations from './Presentations.vue';

    export default {
        name: 'presentations-container',
        components: {
            Presentations,
        },
        computed: {
            ...mapGetters('training', ['presentations']),
        }
    }
</script>


// WEBPACK FOOTER //
// PresentationsContainer.vue?6ac9cba3